import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface EyebrowProps {
    children: ReactNode
    className?: string
}

/**
 * Small section label in the "/ Label" pattern: gold slash, grey text.
 */
export const Eyebrow: FC<EyebrowProps> = ({ children, className }): ReactNode => {
    return (
        <p className={cn('text-sm tracking-wide text-muted-foreground', className)}>
            <span aria-hidden='true' className='mr-1.5 text-gold'>
                /
            </span>

            {children}
        </p>
    )
}
